// src/i18n/en/hmiStaff.js
const hmiStaff = {
    name: 'HMI Staff |||| HMI Staff',

    titles: {
        list: 'HMI Staff',
        create: 'Create HMI Staff',
        edit: 'Edit HMI Staff',
    },

    fields: {
        name: 'Name',
        staffCode: 'Staff Code',
        pin: 'PIN',
        new_pin: 'New PIN',
        pinStatus: 'PIN Status',
        isActive: 'Active',
        hotel: 'Hotel',
    },

    sections: {
        pin: 'PIN Management',
    },

    status: {
        pin_set: 'PIN set',
        pin_not_set: 'No PIN',
        active: 'Active',
        inactive: 'Inactive',
    },

    actions: {
        reset_pin: 'Reset PIN',
    },

    filters: {
        search: 'Search...',
    },

    notifications: {
        created: 'HMI staff member created successfully',
        updated: 'HMI staff member updated successfully',
        pin_reset: 'PIN reset successfully',
    },

    validation: {
        staff_code_format: 'Code must be exactly 2 digits',
        pin_format: 'PIN must be exactly 4 digits',
    },

    errors: {
        pin_in_use: 'This PIN is already in use by another staff member',
        pin_reset_failed: 'Failed to reset PIN',
    },

    help: {
        staff_code: '2-digit code that identifies the staff member',
        pin: '4-digit PIN for HMI terminal access',
        pin_reset_info: 'Enter a new 4-digit PIN for this staff member.',
        login_format: 'HMI access code: %{code} + PIN (6 digits)',
    },
};

export default hmiStaff;
